var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppFeature3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 34.5V43.5C30 44.2956 29.6839 45.0587 29.1213 45.6213C28.5587 46.1839 27.7956 46.5 27 46.5H21C20.2044 46.5 19.4413 46.1839 18.8787 45.6213C18.3161 45.0587 18 44.2956 18 43.5V34.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 40.5H30",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 1.5V4.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 22.5H6",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5L9.7 9.62",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22.5H42",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4998 7.5L38.2998 9.62",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21.5C18.7956 21.5 19.5587 21.8161 20.1213 22.3787C20.6839 22.9413 21 23.7044 21 24.5V34.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27 34.5V24.5C27 23.7044 27.3161 22.9413 27.8787 22.3787C28.4413 21.8161 29.2044 21.5 30 21.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8401 34.5H30.1601C32.3905 33.3953 34.2631 31.6825 35.5618 29.5592C36.8605 27.4359 37.5325 24.9888 37.5001 22.5C37.4385 18.9388 35.9963 15.5408 33.4778 13.0223C30.9594 10.5038 27.5613 9.06168 24.0001 9C20.439 9.06168 17.0409 10.5038 14.5224 13.0223C12.0039 15.5408 10.5618 18.9388 10.5001 22.5C10.4678 24.9888 11.1398 27.4359 12.4385 29.5592C13.7372 31.6825 15.6098 33.3953 17.8401 34.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgAppFeature3;